import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import type { SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { Button, Tooltip } from "@aviary";
import { AppleSSOButton } from "@shared/components/LoginOptions/AppleSSOButton/AppleSSOButton";
import { GoogleSSOButton } from "@shared/components/LoginOptions/GoogleSSOButton/GoogleSSOButton";
import { FontAwesomeIcon } from "@shared/react-fontawesome";
import type { PractitionerAdditionalAttributesType } from "@shared/types/PractitionerAdditionalAttributesType";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./ContinueWithButtons.styles";

interface Props {
  pracTypeId?: string;
  isActive: boolean;
  setIsFormVisible: (value: SetStateAction<boolean>) => void;
  pageVersion: "prac_by_default_with_sso" | "prac_by_default" | "oauth_prac";
  additionalAttributes: PractitionerAdditionalAttributesType;
  isOAuth?: boolean;
}

const ContinueWithButtons = ({
  isActive,
  setIsFormVisible,
  pracTypeId,
  pageVersion,
  additionalAttributes,
  isOAuth,
}: Props) => {
  const { t } = useTranslation();
  const signUpPage = isOAuth ? "oauth_sign_up_page" : "practitioner_sign_up_page";

  return (
    <Tooltip
      isTooltipHidden={isActive}
      placement="bottom"
      tooltipContent={t(l.practitionerSignUp.SelectPractitioner)}
    >
      <div css={styles.fullWidth}>
        <GoogleSSOButton
          css={styles.continueWithButton}
          pracTypeId={pracTypeId}
          disabled={!isActive}
          pageVersion={pageVersion}
          signUpPage={signUpPage}
          additionalAttributes={additionalAttributes}
        />
        <AppleSSOButton
          css={styles.continueWithButton}
          pracTypeId={pracTypeId}
          disabled={!isActive}
          pageVersion={pageVersion}
          signUpPage={signUpPage}
          additionalAttributes={additionalAttributes}
          isOrTextRendered
        />
        <Button
          isColor="system"
          onClick={() => setIsFormVisible(prevState => !prevState)}
          disabled={!isActive}
          data-e2e="continue-with-email"
        >
          <FontAwesomeIcon icon={faEnvelope} size="lg" css={styles.envelope} />
          {t(l.practitionerSignUp.ContinueWithEmail)}
        </Button>
      </div>
    </Tooltip>
  );
};

export { ContinueWithButtons };
